import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useLang } from "../contexts/LanguageContext";

export default function Register() {
  const { register } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const r = await register(email, password, name);
    setBusy(false);
    if (r.ok) navigate("/");
    else setError(r.error);
  };

  return (
    <div className="mx-auto max-w-md px-6 py-20" data-testid="register-page">
      <div className="font-mono text-[10px] uppercase tracking-[0.35em] text-zinc-500 mb-4">
        {t("brand")}
      </div>
      <h1 className="font-serif text-4xl sm:text-5xl text-zinc-50 font-light tracking-tight leading-none">
        {t("register_title")}
      </h1>

      <form onSubmit={onSubmit} className="mt-10 space-y-5" data-testid="register-form">
        <div>
          <label className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
            {t("name")}
          </label>
          <input
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="mt-2 w-full bg-transparent border border-zinc-800 px-4 py-3 text-zinc-100 font-light focus:outline-none focus:border-zinc-500"
            data-testid="register-name-input"
          />
        </div>
        <div>
          <label className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
            {t("email")}
          </label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-2 w-full bg-transparent border border-zinc-800 px-4 py-3 text-zinc-100 font-light focus:outline-none focus:border-zinc-500"
            data-testid="register-email-input"
          />
        </div>
        <div>
          <label className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
            {t("password")}
          </label>
          <input
            type="password"
            required
            minLength={6}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-2 w-full bg-transparent border border-zinc-800 px-4 py-3 text-zinc-100 font-light focus:outline-none focus:border-zinc-500"
            data-testid="register-password-input"
          />
        </div>
        {error && (
          <div className="border border-red-900 bg-red-950/30 text-red-300 px-4 py-3 text-sm" data-testid="register-error">
            {error}
          </div>
        )}
        <button
          type="submit"
          disabled={busy}
          className="w-full bg-sienna text-white py-3 text-sm font-light hover:bg-sienna-400 disabled:opacity-60 transition-colors"
          data-testid="register-submit-button"
        >
          {busy ? t("loading") : t("create_account")}
        </button>
      </form>

      <div className="mt-8 font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">
        {t("already_have")}{" "}
        <Link to="/login" className="text-zinc-100 hover:text-white underline-offset-4 hover:underline" data-testid="register-to-login-link">
          {t("sign_in")}
        </Link>
      </div>
    </div>
  );
}
